@if (isCollapsible()) {
  <div [id]="htmlId()" class="section-end-wrapper" [style.display]="isVisible() ? 'block' : 'none'">
    <span class="section-end">{{ sectionEndLabel }}</span>
  </div>
}
@if (isParentSectionRepeat()) {
  <lfe-repeater-item-form
    [xml]="xml()"
    [form]="form()"
    [sectionItemId]="sectionItemId()"
    [firstSiblingItemId]="firstSiblingItemId()"
    [renderedXmlItems]="renderedXmlItems()"
    [renderedXmlItemsQty]="renderedXmlItems().length"
    [isReadonly]="isReadonly()"
    [user]="user()"
    [settings]="settings()"
    (addNewInstanceRequired)="addNewInstanceRequired.emit($event)" />
}
